import jwt_decode from 'jwt-decode'
import swal from 'sweetalert'
import { privateAPI, privateAPIFormData, publicAPI, utilUrl } from '../../config/constants'
import { decrypt, gettokenData } from '../../functions/globalFunctions'
import { getMonitorings } from '../actions/campaignActions'
import * as generalTypes from '../types/generalTypes'

let tokenData
if (localStorage.getItem('token')) {
  let token = jwt_decode(localStorage.getItem('token'))
  tokenData = decrypt(token.data)
}

export const sendMessageCustomer = (payload) => {
  return async (dispatch) => {
    try {
      await privateAPIFormData.post('/create-campaign', payload).then((res) => {
        dispatch(getMonitorings())
        swal('', res?.data?.message, 'success')
      })
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}
export const sendAppCustomer = (payload) => {
  return async (dispatch) => {
    try {
      await privateAPIFormData.post('/create-app-campaign', payload).then((res) => {
        dispatch(getMonitorings())
        swal('', res?.data?.message, 'success')
      })
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}
export const sendMessageCustomerWithQuery = (payload) => {
  return async (dispatch) => {
    try {
      await privateAPIFormData.post('/create-campaign-with-query', payload).then((res) => {
        dispatch(getMonitorings())
        swal('', res?.data?.message, 'success')
      })
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}
export const sendAppCustomerWithQuery = (payload) => {
  return async (dispatch) => {
    try {
      await privateAPIFormData
        .post('/create-app-campaign-with-query', payload)
        .then((res) => {
          dispatch(getMonitorings())
          swal('', res?.data?.message, 'success')
        })
        .catch((error) => {
          console.log('in catch', error)
          swal('', error?.response?.data?.message, 'error')
        })
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}

export const sendEmailCustomerWithQuery = (payload) => {
  return async (dispatch) => {
    try {
      await privateAPIFormData.post('/create-email-campaign-with-query', payload).then((res) => {
        dispatch(getMonitorings())
        swal('', res?.data?.message, 'success')
        console.log('with query res', res?.data?.message)
      })
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}

export const sendEmailCustomerWithOutQuery = (payload) => {
  return async (dispatch) => {
    try {
      await privateAPIFormData.post('/create-email-campaign-without-query', payload).then((res) => {
        dispatch(getMonitorings())
        swal('', res?.data?.message, 'success')
      })
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}

export const updateCampaign = (payload) => {
  return async (dispatch) => {
    try {
      let res = await privateAPI.post('/update-campaign', { data: { ...payload } })
      if (res) {
        dispatch(getMonitorings())
        swal('', res?.data?.message, 'success').then(() => window.location.reload())
        return res?.data?.data
      }
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}

export const getRefreshMonitorings = async (campaign) => {
  const res = await privateAPI.post(`/campaign/refresh-campaign-monitoring`, {
    data: { id: campaign },
  })
  console.log('decrypt(res.data)', res)
  // if(res.data?.message){
  return res?.data?.message
  // }else{
  //   return
  // }
}

export const deleteThisCampaign = async (campaign) => {
  const res = await privateAPI.post(`/delete-campaign`, {
    data: { campaignId: campaign },
  })
  console.log('decrypt(res.data)', res?.data?.campaign)
  return res?.data?.campaign
}

export const toggleCampaign = async (campaign) => {
  const res = await privateAPI.post(`/toggle-campaign-status`, {
    data: { campaignId: campaign },
  })
  console.log('decrypt(res.data)', res?.data?.campaign)
  return res?.data?.campaign
}

export const sendSocialMediaCustomer = (payload) => {
  return async (dispatch) => {
    try {
      await privateAPIFormData
        .post('/create-social-media-campaign', { data: { ...payload } })
        .then((res) => {
          dispatch(getMonitorings())
          swal('', res?.data?.message, 'success')
        })
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}

export const sendEmailCustomer = (payload) => {
  return async (dispatch) => {
    try {
      await privateAPI.post('/save-mail', { data: { ...payload } }).then((res) => {
        dispatch(getMonitorings())
        swal('', res?.data?.message, 'success')
      })
    } catch (error) {
      console.log(error)
    }
  }
}

export const setMode = (mode) => {
  return async (dispatch) => {
    dispatch({
      type: generalTypes.CUSTOMER_MODE,
      payload: mode,
    })
  }
}
export const setDefaultMode = () => {
  return async (dispatch) => {
    dispatch({
      type: generalTypes.DEFAULT_CUSTOMER_MODE,
    })
  }
}

export const uploadFile = (formData) => {
  return async () => {
    const res = await publicAPI.post(`/uploadFile`, formData)
    if (res) {
      return res.data.imageUrl
    }
  }
}
export const returningCustomerState = (payload, setData, setReturningCustomerLoading) => {
  return async () => {
    setReturningCustomerLoading(true)
    const data = { ...payload }
    await privateAPI
      .post(`/offline/get-returning-customer-state`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setData(resp)
        setReturningCustomerLoading(false)
      })
      .catch((error) => {
        console.log('error', error)
        setReturningCustomerLoading(false)
      })
  }
}
export const newCustomerState = (payload, setData, setNewCustomerLoading) => {
  return async () => {
    setNewCustomerLoading(true)
    const data = { ...payload }
    await privateAPI
      .post(`/offline/get-new-customer`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)

        setData(resp)

        setNewCustomerLoading(false)
      })
      .catch((error) => {
        console.log(error)
        setNewCustomerLoading(false)
      })
  }
}

export const buyingBehaviourAnalysis = (payload) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/buying-behaviour-analysis/${tokenData?.vendorId}`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        return resp
      })
  }
}

export const subCategorySale = (setSubData, setCategoryWiseSalesLoading) => {
  return async () => {
    setCategoryWiseSalesLoading(true)
    setSubData(null)

    await privateAPI.post(`/offline/sub-category-sale`).then((res) => {
      const resp = decrypt(res.data)
      setCategoryWiseSalesLoading(false)
      setSubData(resp.data)
    })
  }
}

export const lastOneYearSale = (setLastYearSale, mode) => {
  return async () => {
    await privateAPI.post(`/offline/last-one-year-sale`, { mode }).then((res) => {
      const resp = decrypt(res.data)
      setLastYearSale(resp.data)
      return resp
    })
  }
}

export const segmentTransition = (payload, setData, setTotalCount) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data/${tokenData?.vendorId}`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setData(resp.data)
        setTotalCount(resp.totalCount)

        return resp
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const returningCustomerBehavior = (payload) => {
  return async () => {
    const data = { ...payload }
    const res = await privateAPI.post(
      `/offline/returning-customer-behavior/${tokenData?.vendorId}`,
      {
        data,
      },
    )
    if (res) {
      const resp = decrypt(res.data)
      return resp
    }
  }
}
export const rfmAnalysisChartData = (payload, setRfmData, setrfmDataLoading) => {
  return async () => {
    setrfmDataLoading(true)
    setRfmData(null)
    await privateAPI
    const data = { ...payload }
      // offline/rfm-analysis-chart-data
      .post(`/offline/get-returning-customer-state`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)

        setRfmData(resp)
        setrfmDataLoading(false)

        return resp
      })
  }
}

export const rfmAnalysisTwelveMonths = (
  payload,
  setPreviousTwelveMonths,
  setPreviousTwelveMonthsLoading,
) => {
  return async () => {
    setPreviousTwelveMonthsLoading(true)
    setPreviousTwelveMonths(null)
    await privateAPI
    const data = { ...payload }
      // offline/rfm-analysis-chart-data
      .post(`/offline/get-returning-customer-state-prevoius-twelve-months`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setPreviousTwelveMonths(resp)
        setPreviousTwelveMonthsLoading(false)

        return resp
      })
  }
}

export const segmentTransitionByDateNewCustomer = (payload, setNewCustomer) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-new-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setNewCustomer(resp)
        return resp
      })
  }
}

export const segmentTransitionByDateTotalCustomer = (payload, setTotal) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-total-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setTotal(resp)
      })
  }
}
export const segmentTransitionByDateReturningCustomer = (payload, setReturningCustomer) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-returning-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setReturningCustomer(resp)
        return resp
      })
  }
}

export const segmentTransitionByDateAtRiskCustomer = (payload, setAtRisk) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-atrisk-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setAtRisk(resp)
      })
  }
}

export const segmentTransitionByDateneedAttationCustomer = (payload, needattention) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-needattention-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        needattention(resp)
        return resp
      })
  }
}

export const segmentTransitionByDatelostCustomer = (payload, setLostCustomer) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-lost-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setLostCustomer(resp)
        return resp
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const segmentTransitionByDateBaseCustomer = (payload, setBaseCUstomer) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-base-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setBaseCUstomer(resp)
        return resp
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const segmentTransitionByDateStarCustomer = (payload, setStarCUstomer) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-star-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setStarCUstomer(resp)
        return resp
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const segmentTransitionByDateChampionCustomer = (payload, setChampionCustomer) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-champion-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setChampionCustomer(resp)
        return resp
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const segmentTransitionByDateNotToLoosCustomer = (payload, setNotToLoosCustomer) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-nottoloose-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setNotToLoosCustomer(resp)
        return resp
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const segmentTransitionByDateLoyalCustomer = (payload, setLoyalCustomer) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/offline/segment-transition-data-loyal-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)

        setLoyalCustomer(resp)
        return resp
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const topFiveProductsPurchased = (payload, setTopFiveData, setTopFiveDataLoading) => {
  return async () => {
    setTopFiveDataLoading(true)
    setTopFiveData(null)
    const data = { ...payload }
    await privateAPI
      .post(`/offline/top-five-products-purchased`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setTopFiveData(resp)
        setTopFiveDataLoading(false)

        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const topTenProductPurchased = (payload, setTopTenProducts, setTopTenProductsLoading) => {
  return async () => {
    setTopTenProductsLoading(true)
    setTopTenProducts(null)
    const data = { ...payload }
    await privateAPI
      .post(`/offline/top-ten-products`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setTopTenProductsLoading(false)
        setTopTenProducts(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const lastYearMonthWiseSale = (
  payload,
  setMonthWiseYearlySale,
  setMonthWiseYearlySaleLoading,
) => {
  return async () => {
    setMonthWiseYearlySaleLoading(true)
    setMonthWiseYearlySale(null)
    const data = { ...payload }
    await privateAPI
      .post(`/offline/last-year-month-wise-sale`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)

        setMonthWiseYearlySaleLoading(false)
        setMonthWiseYearlySale(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const returningCustomerByRFMShop = (
  payload,
  setReturningCustomerByShop,
  setReturningCustomerByShopLoading,
) => {
  return async () => {
    setReturningCustomerByShopLoading(true)
    setReturningCustomerByShop(null)

    const data = { ...payload }
    await privateAPI
      .post(`/offline/returning-customer-by-shop`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setReturningCustomerByShop(resp)
        setReturningCustomerByShopLoading(false)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const getCampaignRespondedCustomers = (payload, setData) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/campaign/get-campaign-responded-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setData(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const getVendorShifts = (payload, setState) => {
  return async () => {
    const res = await privateAPI.post(`${utilUrl}/get-vendor-shift-analysis`, {
      data: {
        timePeriod: payload,
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = res.data
      setState(resp)
      // return resp
    }
  }
}
export const getVendorBehavioAnalysis = (payload, setState) => {
  return async () => {
    const res = await privateAPI.post(`${utilUrl}/get-vendor-behavior-analysis`, {
      data: {
        timePeriod: payload,
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = res.data
      setState(resp)
      // return resp
    }
  }
}

export const getYourWinBackStats = (payload, setState) => {
  return async () => {
    const res = await privateAPI.post(`${utilUrl}/get-your-win-back-stats`, {
      data: {
        timePeriod: payload,
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = res.data
      setState(resp)
      // return resp
    }
  }
}

export const getVendorShiftsNumbers = (payload, key, setState) => {
  return async () => {
    const res = await privateAPI.post(`${utilUrl}/get-vendor-shifts-by-category/`, {
      data: {
        timePeriod: payload,
        name: key,
        vendorId: gettokenData()?.vendorId,
      },
    })
    if (res) {
      let resp = res.data
      setState(resp)
      // return resp
    }
  }
}

export const shiftAnalysisBaseToStar = (payload, setBaseToStar) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/synopsis/shift-analysis-base-to-star`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setBaseToStar(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const shiftAnalysisStarToMustNotLoss = (payload, setStarToMustNotLoss) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/synopsis/shift-analysis-star-to-must-not-loss`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setStarToMustNotLoss(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}
export const shiftAnalysisMustNotLossToChampions = (payload, setMustNotLossToChampions) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/synopsis/shift-analysis-must-not-loss-to-champaigns`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setMustNotLossToChampions(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const shiftAnalysisAdditionOfNewCustomers = (payload, setAdditionOfNewCustomers) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/synopsis/shift-analysis-addition-of-new-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setAdditionOfNewCustomers(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}
export const shiftAnalysisLostCustomers = (payload, setLostCustomers) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/synopsis/shift-analysis-lost-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setLostCustomers(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const getselectAudienceName = (setSelectAudienceState) => {
  return async () => {
    await privateAPI.post(`/offline/select-audience`).then((res) => {
      const resp = decrypt(res.data)
      setSelectAudienceState(resp)
      // return resp;
      // dispatch(getMonitorings());
      // swal("", res?.data?.message, "success");
    })
  }
}

export const getSelectedAudienceData = (payload, setSelectedAudienceData, setCrmTableLoading) => {
  return async () => {
    setCrmTableLoading(true)
    await privateAPI
      .post(`/offline/get-selected-audience-data`, {
        data: { ...payload },
      })
      .then((res) => {
        setCrmTableLoading(false)
        const resp = decrypt(res.data)
        setSelectedAudienceData(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const uploadCRMAudience = (payload) => {
  return async () => {
    return await privateAPIFormData
      .post(`/offline/upload-crm-audience`, payload)
      // .post(`/offline/upload-crm-audience`, {data : payload, mode: mode})
      .then(() => {
        swal('Audience Uploaded Successfully', '', 'success')
        return true
      })
      .catch((error) => {
        swal('', error.response.data.message, 'error')
        return false
      })
  }
}

export const shiftAnalysisRiskCustomers = (payload, setRiskCustomer) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/synopsis/shift-analysis-atrisk-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setRiskCustomer(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}

export const shiftAnalysisNeedAttationCustomers = (payload, setNeedAttention) => {
  return async () => {
    const data = { ...payload }
    await privateAPI
      .post(`/synopsis/shift-analysis-need-attantion-customers`, {
        data,
      })
      .then((res) => {
        const resp = decrypt(res.data)
        setNeedAttention(resp)
        // return resp;
        // dispatch(getMonitorings());
        // swal("", res?.data?.message, "success");
      })
  }
}
